import { Product } from "../api/Product";

export function isProductDiscount(product: Product) {
  return (
    product.prices.maxDiscountPrice !== null ||
    product.prices.minDiscountPrice !== null
  );
}

export function getDiscountPrice(product: Product) {
  return (
    product.prices.maxDiscountPrice ||
    product.prices.maxDiscountPrice ||
    undefined
  );
}

export function isProductTypesSale(productType: Product["types"][0]) {
  return productType.discountPrice !== null;
}
